module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Frederick Ramsay\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Frederick Ramsay was raised on the east coast and attended graduate school in Chicago. He was a writer of mysteries set in Virginia, (the Ike Schwartz Mysteries) Botswana Mystery series, Jerusalem Mystery series and stand-alones (Impulse, Judas: The Gospel of Betrayal). He was a retired Episcopal Priest, Academic, and author.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/kgql8v/tc-custom/9781615951680.jpg?1732132327534",
      "alt": "This image is the cover for the book Stranger Room, Ike Schwartz Series"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Stranger Room, Ike Schwartz Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("\"Ramsay skillfully weaves historical fact into his story, all the while blending brisk action with excellent characterization.\" —"), _c('i', [_vm._v("Publishers Weekly")])])]), _c('p', [_vm._v("Elderly Jonathan Lydell III is proud of his lineage. He is related to the Virginia Lees and to the Custis family. For Lydell, family, status, and history are the only realities—that and his antebellum house.")]), _c('p', [_vm._v("Lydell's house has a very colorful history, and Lydell is committed to restoring it to its pre-Civil War configuration, complete with a \"stranger room.\" In the 1800s, many family homes sported these attached rooms with separate entrances and locks that were kept ready for unknown travelers. The intent was to protect the family from unsavory guests.")]), _c('p', [_vm._v("Nearly 150 years ago, an inexplicable murder took place inside the Lydell's locked stranger room. The murderer was never caught. Lydell thinks this brutal history adds to the house's rich character. But when an identical murder is committed in the newly restored stranger room, even Sheriff Ike Schwartz and FBI agent Karl Hedrick can't explain it....")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Poisoned Pen Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0